import axios from '../axios-auth';
import orginal_axios from "axios";


export const menuReportService = {
    getMenuReportList,
    getAllMenuReportList,
    exportMenuReportExcel,
    getMenuReportSummary,
    getMenuReportDetailList
}

function getMenuReportList(searchParams, page, size, sortedBy) {
    let url = '/auth/menu-report/';
    let params = {};
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    if (sortedBy == 'null,asc') {
        params["page"] = page;
        params["size"] = size;
    } else {
        params["page"] = page;
        params["size"] = size;
        params["sort"] = sortedBy;
    }
    if (searchParams.menuName) {
        params["menuName"] = searchParams.menuName;
    }
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.saleType) {
        params["saleType"] = searchParams.saleType;
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }
    return axios.get(url, { params });
}

function getAllMenuReportList(searchParams) {
    let url = '/auth/menu-report/';
    let params = {};
    if (searchParams.menuName) {
        params["menuName"] = searchParams.menuName;
    }
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.saleType) {
        params["saleType"] = searchParams.saleType;
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }
    return axios.get(url, { params });

}

function exportMenuReportExcel(searchParams) {
    let url = '/auth/menu-report-excel?';

    if (searchParams.menuName) {
        url += '&menuName=' + searchParams.menuName;
    }
    if (searchParams.productCode) {
        url += '&productCode=' + searchParams.productCode;
    }
    if (searchParams.categoryId) {
        url += '&categoryId=' + searchParams.categoryId;
    }

    if (searchParams.brandId) {
        url += '&brandId=' + searchParams.brandId;
    }
    if (searchParams.productGroupId) {
        url += '&productGroupId=' + searchParams.productGroupId
    }

    if (searchParams.shopId) {
        url += '&shopId=' + searchParams.shopId;
    }

    if (searchParams.fromDate) {
        url += '&fromDate=' + searchParams.fromDate;
    }
    if (searchParams.toDate) {
        url += '&toDate=' + searchParams.toDate;
    }
    if (searchParams.saleType) {
        url += '&saleType=' + searchParams.saleType;
    }
    if (searchParams.currencyId) {
        url += '&currencyId=' + searchParams.currencyId;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + url,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getMenuReportSummary(searchParams) {
    let url = '/auth/menu-report-summary/';
    let params = {};
    if (searchParams.menuName) {
        params["menuName"] = searchParams.menuName;
    }
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.categoryId) {
        params["categoryId"] = searchParams.categoryId;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.productGroupId) {
        params["productGroupId"] = searchParams.productGroupId;
    }
    if (searchParams.saleType) {
        params["saleType"] = searchParams.saleType;
    }
    if (searchParams.currencyId) {
        params["currencyId"] = searchParams.currencyId;
    }
    return axios.get(url, { params });
}

function getMenuReportDetailList(searchParams) {
    let params = {};

    if(searchParams.saleType) {
        params["saleType"] = searchParams.saleType;
    }

    if(searchParams.shopName) {
        params["shopName"] = searchParams.shopName;
    }

    if(searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }

    if(searchParams.factorUnitName){
        params["factorUnitName"] = searchParams.factorUnitName;
    }

    if(searchParams.unitPrice){
        params["unitPrice"] = searchParams.unitPrice;
    }

    if(searchParams.fromDate){
        params["fromDate"] = searchParams.fromDate;
    }

    if(searchParams.toDate){
        params["toDate"] = searchParams.toDate;
    }

    if(searchParams.issueNo){
        params["issueNo"] = searchParams.issueNo;
    }

    return axios.get("/auth/menu-report-detail",{params})
}
